import { DownloadOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

import { useDownloadExcel } from '@hooks'

import { StyledCenteredIcon } from '../StyledComponents'

type Props = {
  id: number
}

const DownloadExcel: React.FC<Props> = ({ id }) => {
  const { downloadFile, isLoading } = useDownloadExcel()

  return (
    <>
      <StyledCenteredIcon>
        {isLoading ? (
          <Spin spinning />
        ) : (
          <DownloadOutlined style={{ cursor: 'pointer' }} onClick={() => downloadFile({ id })} />
        )}
      </StyledCenteredIcon>
    </>
  )
}

export { DownloadExcel }
